export interface ProviderNameFields {
  first_name?: string | null;
  last_name?: string | null;
  name?: string | null;
}

export function formatProviderFullName(provider?: ProviderNameFields | null): string {
  if (!provider) return 'Unknown Provider';
  return (
    [provider.first_name, provider.last_name].filter(Boolean).join(' ').trim() ||
    provider.name ||
    'Unknown Provider'
  );
}
